// src/utils/parseEntitlements.js

export function parseEntitlementResponse(apiResponse) {
    const entitlementsMap = {};
  
    if (!Array.isArray(apiResponse)) {
      console.warn("Invalid entitlement response:", apiResponse);
      return entitlementsMap;
    }
  
    apiResponse.forEach(role => {
      (role.resources || []).forEach(resource => {
        const resourceName = resource.name;
  
        (resource.entitlements || []).forEach(action => {
          const key = `${resourceName}:${action}`;
          entitlementsMap[key] = true;
        });
      });
    });
  
    return entitlementsMap;
  }

export const getResourcesFromEntitlements = (ent, role) => {
  if (!ent) return [];
  if (Array.isArray(ent)) {
    if (role) {
      const matched = ent.find(r => r.role && r.role.toLowerCase() === role.toLowerCase());
      if (matched && Array.isArray(matched.resources)) return matched.resources;
    }
    // fallback: flatten resources across all roles
    return ent.flatMap(r => r.resources || []);
  }
  // single-role shape
  return Array.isArray(ent.resources) ? ent.resources : [];
};

export const buildEntitlementMap = (entitlementsData, profileRole) => {
  const resources = getResourcesFromEntitlements(entitlementsData, profileRole);
  const map = {};
  resources.forEach(resource => {
    const name = resource.name;
    (resource.entitlements || []).forEach(action => {
      map[`${name}:${action}`] = true;
    });
  });
  return map;
};

export const userHasEntitlement = (entitlementsData, profileRole, resourceName, entitlement) => {
  if (!entitlementsData) return false;
  const map = buildEntitlementMap(entitlementsData, profileRole);
  return !!map[`${resourceName}:${entitlement}`];
};
